export default "/images/vendor/flag-icon-css/flags/4x3/lb.svg?4e42399a0ba45809df5ba490b4d9120e";